import { Fragment } from 'react';

import useIsInViewport from 'use-is-in-viewport';

import { useFormFieldUpdatedEvent } from '@nerdwallet/analytics/react/form';
import ConfigBuilder, { applyMacros } from '@nerdwallet/react-config-builder';

import formatEventValue from './format-event-value';

// Adds form_field_updated tracking to ConfigBuilder
const ConfigBuilderWrapper = (configBuilderProps) => {
  const { viewConfig, data, analyticsDisabled = false } = configBuilderProps;
  const [isInViewport, wrappedTargetRef] = useIsInViewport();

  const formFieldUpdatedEvent = (() => {
    const { analytics, getValidationConfig } = viewConfig;

    // If the config is not for a trackable input, stop here.
    // useFormFieldUpdatedEvent will not fire an event if the passed in args never change
    if (
      !analytics ||
      !getValidationConfig ||
      !data ||
      !isInViewport ||
      analyticsDisabled
    ) {
      return { disabled: true };
    }

    const { eventType, payload, valueFieldName, mapValue } = analytics;
    const { isValid, feedback } = getValidationConfig(data);
    const { value: formattedValue } = applyMacros(viewConfig, data);

    return {
      eventType,
      payload: {
        ...payload,
        ...formatEventValue({
          formattedValue,
          valueFieldName,
          mapValue,
          isValid,
          feedback,
        }),
        is_valid: isValid,
      },
    };
  })();

  useFormFieldUpdatedEvent(formFieldUpdatedEvent);

  return (
    <Fragment>
      <div ref={wrappedTargetRef} />
      <ConfigBuilder {...configBuilderProps} />
    </Fragment>
  );
};

ConfigBuilderWrapper.propTypes = ConfigBuilder.propTypes;
ConfigBuilderWrapper.defaultProps = ConfigBuilder.defaultProps;

export default ConfigBuilderWrapper;
